import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "@env/environment";
import {take, tap} from "rxjs/operators";
import {Accommodation} from "@app-model/accommodation";
import {Material} from "@app-model/material";
import {FuelType} from "@app-model/fuel-type";
import {Transport} from "@app-model/transport";
import {Airport} from "@app-model/airport";
import {AvailableStages} from "@app-model/available-stages";
import {Stages} from "@app-shared/enums/stages";
import {EmissionsResponse} from "@app-model/emmisions-response";
import {EmissionsControllerService} from "@app-services/emissions-controller.service";
import {EmissionsRequest} from "@app-model/emissions-request";
import {ProjectData, ProjectInfo} from "@app-model/project-data";


@Injectable()
export class CalculateService {
    projectData: ProjectInfo;


    constructor(
        private _http: HttpClient,
        private _emissionsControllerService: EmissionsControllerService,
    ) {
    }

    getAvailableStages(): Observable<AvailableStages[]> {
        return this._http.get<AvailableStages[]>(`${environment.api}/calculator/projects/available-stages`)
            .pipe(
                take(1),
            );
    }

    getAccommodations(): Observable<Accommodation[]> {
        return this._http.get<Accommodation[]>(`${environment.api}/calculator/accommodations`)
            .pipe(
                take(1),
            );
    }

    getMaterials(): Observable<Material[]> {
        return this._http.get<Material[]>(`${environment.api}/calculator/materials`)
            .pipe(
                take(1),
            );
    }

    getFuelsTypes(): Observable<FuelType[]> {
        return this._http.get<FuelType[]>(`${environment.api}/calculator/fuel-consumption-types`)
            .pipe(
                take(1),
            );
    }

    getTransports(): Observable<Transport[]> {
        return this._http.get<Transport[]>(`${environment.api}/calculator/transports`)
            .pipe(
                take(1),
            );
    }

    getAirports(airport?: string): Observable<Airport[]> {
        return this._http.get<Airport[]>(`${environment.api}/calculator/airports`, {
            params: new HttpParams().set('query', airport ?? '')
        })
            .pipe(
                take(1),
            );
    }

    getEmissionsByStage(companyId: string, stage: Stages): Observable<EmissionsResponse> {
        return this._http.get<EmissionsResponse>(`${environment.api}/calculator/projects/${companyId}/stages/${stage}/emissions`)
            .pipe(
                take(1),
            );
    }

    saveProjectEmissions(id:string, stage: Stages): Observable<any> {

        const bodyPayload: EmissionsRequest = this._emissionsControllerService.getEmissionsPayloadRequest();
        return this._http
            .put<any>(`${environment.api}/calculator/projects/${id}/stages/${stage}/emissions`, bodyPayload)
            .pipe(
                take(1),
            );
    }

    getProjectInfo(id:string): Observable<ProjectData> {
        
        return this._http.get<ProjectData>(`${environment.api}/projects/${id}`)
            .pipe(
                take(1),
            );
    }

    deleteStageProjectEmissions(): Observable<any> {
        
        return this._http
            .delete<any>(`${environment.api}/calculator/projects/${this.projectData.id}/stages/${this.projectData.stage}/emissions`)
            .pipe(
                take(1),
            );
    }

    setProjectData(id:string, stage: Stages): void {
        this.projectData = {
            id,
            stage
        };
    }
    clearProjectData():void {
        this.projectData = null;
    }
    getProjectData(): ProjectInfo {
        return this.projectData;
    }


}

